const en = {
  ID_QUICK_CHAT_HELLO: "Hello",
  ID_QUICK_CHAT_COOL: "That's cool",
  ID_QUICK_CHAT_HAHA: "LOL",
  ID_QUICK_CHAT_GO_GAME: "Let's play a game",
  ID_QUICK_CHAT_LATER: "See you later",
  ID_QUICK_CHAT_WAIT: "Hold on",
  ID_QUICK_CHAT_HI: "Hi~",
  ID_QUICK_CHAT_LETS_GO: "Let's go!",
  ID_QUICK_CHAT_NICE_TO_MEET_YOU: "Nice to meet you",
  ID_QUICK_CHAT_TAKE_A_SELFIE: "Take a selfie",
};

export default en;
